import { HttpClient } from '@angular/common/http';
import {
  EventEmitter,
  Injectable,
  Output,
  inject,
  signal,
} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../environments/environment';
import { AuthModalComponent } from '../components/layout/auth-modal/auth-modal.component';
import { ApiHttpService } from './auth/api-http.service';
import { AuthService } from './auth/auth.service';
import { FavoritesService } from './favorite/favorites.service';
import { SportsService } from './sport.service';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private newsFavoritesService = inject(FavoritesService);

  private urlAPI = environment.API;

  @Output() changeFavorites = new EventEmitter<any>();
  @Output() changeCompetitionsFavorites = new EventEmitter<any>();
  @Output() changeTeamFavorites = new EventEmitter<any>();

  v1favoriteCompetitionIds = signal<Record<string, string>>({});
  v1favoriteMatchIds = signal<Record<string, string>>({});
  v1favoriteTeamIds = signal<Record<string, string>>({});

  // LOCAL STORAGE KEYS
  teamKey = 'TeamFavorites';
  matchKey = 'MatchesFavorites';
  competitionKey = 'CompetitionFavorites';

  private deviceId: any;

  constructor(
    private readonly sportsServices: SportsService,
    private readonly translatorService: TranslationService,
    private http: HttpClient,
    public api: ApiHttpService,
    public authServices: AuthService,
    private modalService: NzModalService
  ) {
    // routes.post('/pushtoken', fbAuthorize.userAuthorize, AddToken);
    this.getDeviceId();
    this.changeFavorites.subscribe(() => {
      // this.getFavorites(true).subscribe();
    });
  }

  getDeviceId() {
    if (!localStorage.getItem('unique-id'))
      localStorage.setItem('unique-id', uuidv4());

    this.deviceId = localStorage.getItem('unique-id');
    // this.getFavorites(true).subscribe();
  }

  getFavoriteFromLocal(type: 'TEAM' | 'COMPETITION' | 'MATCH') {
    let localStorageKey = '';
    switch (type) {
      case 'TEAM':
        localStorageKey = this.teamKey;
        break;

      // case 'COMPETITION':
      //   localStorageKey = this.competitionKey;
      //   break;

      case 'MATCH':
        localStorageKey = this.matchKey;
        break;

      default:
        break;
    }
    const matchs: any = localStorage.getItem(localStorageKey);
    return matchs ? JSON.parse(matchs) : [];
  }

  isUserLoggedIn(): boolean {
    if (!this.authServices.isLoggedIn) {
      this.modalService.create({
        nzContent: AuthModalComponent,
        nzFooter: null,
      });
    }
    return this.authServices.isLoggedIn;
  }
  // TODO: delete favorito
  // setFavoritesCompetition(
  //   competition: DashboardScore,
  //   hasSport: any = null
  // ): boolean {
  //   if (!this.isUserLoggedIn()) {
  //     return false;
  //   }

  //   let competitionMarked: any = this.getFavoriteFromLocal('COMPETITION');
  //   const existId: any = competitionMarked.findIndex(
  //     (elem: any) => elem.idCompetition === competition.idCompetition
  //   );
  //   localStorage.removeItem(this.competitionKey);
  //   if (existId > -1) {
  //     const favoriteId =
  //       this.v1favoriteCompetitionIds()[competition.idCompetition];

  //     this.http
  //       .delete<any>(`${this.urlAPI}favorites/${favoriteId}`)
  //       .subscribe((response) => {
  //         if (response.success) {
  //           competitionMarked.splice(existId, 1);
  //           localStorage.setItem(
  //             this.competitionKey,
  //             JSON.stringify(competitionMarked)
  //           );

  //           this.validateCompettionFavoriteWhenDelete(
  //             competition.idCompetition
  //           );

  //           this.newsFavoritesService.idsCompetitionFavorites.update((prev) => {
  //             return prev.filter((id) => id !== competition.idCompetition);
  //           });
  //           this.changeCompetitionsFavorites.emit(
  //             this.getFavoriteFromLocal('COMPETITION')
  //           );
  //           this.changeFavorites.emit();
  //         }
  //       });
  //     // this.getFavorites(true).subscribe(({ data }) => {
  //     //   const favoriteId = data.CompetitionFavorites.find(
  //     //     (x: any) => x.idCompetition === competition.idCompetition
  //     //   )?.favoriteId;

  //     // });
  //     // this.getFavorites(true).subscribe(({ data }) => {
  //     //   const favoriteId = data.CompetitionFavorites.find(
  //     //     (x: any) => x.idCompetition === competition.idCompetition
  //     //   )?.favoriteId;

  //     //   this.http
  //     //     .delete<any>(`${this.urlAPI}favorites/${favoriteId}`)
  //     //     .subscribe((response) => {
  //     //       if (response.success) {
  //     //         competitionMarked.splice(existId, 1);
  //     //         localStorage.setItem(
  //     //           this.competitionKey,
  //     //           JSON.stringify(competitionMarked)
  //     //         );

  //     //         this.validateCompettionFavoriteWhenDelete(
  //     //           competition.idCompetition
  //     //         );

  //     //         this.newsFavoritesService.idsCompetitionFavorites.update(
  //     //           (prev) => {
  //     //             return prev.filter((id) => id !== competition.idCompetition);
  //     //           }
  //     //         );

  //     //         this.changeFavorites.emit();
  //     //       }
  //     //     });
  //     // });
  //   } else {
  //     const jsonData = {
  //       idCompetition: competition.idCompetition,
  //       nameEs: competition.nameEs,
  //       nameEn: competition.nameEn,
  //       competitionLogo: competition.competitionLogo,
  //       country: competition.country,
  //       sport: hasSport ? hasSport : this.sportsServices.getSelectedSport(),
  //     };
  //     this.http
  //       .post<any>(`${this.urlAPI}user/favorites`, {
  //         deviceId: this.deviceId,
  //         type: 'competition',
  //         record_id: competition.idCompetition,
  //         jsonData,
  //         language: this.translatorService.getCurrentLanguage(),
  //         sport: hasSport ? hasSport : this.sportsServices.getSelectedSport(),
  //         uid: this.authServices.userInfo.user?.id,
  //       })
  //       .subscribe((response) => {
  //         competitionMarked.unshift(jsonData);

  //         localStorage.setItem(
  //           this.competitionKey,
  //           JSON.stringify(competitionMarked)
  //         );

  //         // console.log('agrego');
  //         this.newsFavoritesService.idsCompetitionFavorites.update((prev) => [
  //           ...prev,
  //           competition.idCompetition,
  //         ]);
  //         this.changeCompetitionsFavorites.emit(
  //           this.getFavoriteFromLocal('COMPETITION')
  //         );
  //         this.validateCompettionFavoriteWhenAdded(competition.idCompetition);
  //         this.changeFavorites.emit();
  //       });
  //   }

  //   return true;
  // }

  setFavoritesMatch(
    match: any,
    idCompetition: any,
    dateMatch: any,
    hasSport: any = null
  ): boolean {
    if (!this.isUserLoggedIn()) {
      return false;
    }
    let matchsMarked: any = this.getFavoriteFromLocal('MATCH');
    const existId: any = matchsMarked.findIndex(
      (elem: any) => String(elem.idMatch) === String(match.id)
    );

    localStorage.removeItem(this.matchKey);
    if (existId > -1) {
      const favoriteId = this.v1favoriteMatchIds()[match.id];

      this.http
        .delete<any>(`${this.urlAPI}favorites/${favoriteId}`)
        .subscribe((response) => {
          if (response.success) {
            matchsMarked.splice(existId, 1);
            localStorage.setItem(this.matchKey, JSON.stringify(matchsMarked));

            this.validateMatchFavoriteWhenDelete(match.id);

            this.changeFavorites.emit();
          }
        });
      // this.getFavorites(true).subscribe(({ data }) => {
      //   const favoriteId = data.MatchesFavorites.find(
      //     (x: any) => String(x.idMatch) === String(match.id)
      //   )?.favoriteId;
      //   this.http
      //     .delete<any>(`${this.urlAPI}favorites/${favoriteId}`)
      //     .subscribe((response) => {
      //       if (response.success) {
      //         matchsMarked.splice(existId, 1);
      //         localStorage.setItem(this.matchKey, JSON.stringify(matchsMarked));

      //         this.validateMatchFavoriteWhenDelete(match.id);

      //         this.changeFavorites.emit();
      //       }
      //     });
      // });
    } else {
      const jsonData = {
        idMatch: match.id,
        homeTeam: match.homeTeam,
        awayTeam: match.awayTeam,
        idCompetition,
        dateMatch,
        sport: hasSport ? hasSport : this.sportsServices.getSelectedSport(),
      };
      this.http
        .post<any>(`${this.urlAPI}user/favorites`, {
          deviceId: this.deviceId,
          type: 'match',
          record_id: match.id,
          jsonData,
          language: this.translatorService.getCurrentLanguage(),
          sport: hasSport ? hasSport : this.sportsServices.getSelectedSport(),
          uid: this.authServices.userInfo.user?.id,
        })
        .subscribe((response) => {
          matchsMarked.unshift(jsonData);
          matchsMarked.sort((a: any, b: any) =>
            parseInt(a.dateMatch) < parseInt(b.dateMatch)
              ? 1
              : parseInt(a.dateMatch) > parseInt(b.dateMatch)
              ? -1
              : 0
          );

          localStorage.setItem(this.matchKey, JSON.stringify(matchsMarked));
          this.validateMatchFavoriteWhenAdded(match.id);

          this.changeFavorites.emit();
        });
    }

    return true;
  }

  setFavoritesTeam(team: any, hasSport: any = null): boolean {
    if (!this.isUserLoggedIn()) {
      return false;
    }

    let teamsMarked: any = this.getFavoriteFromLocal('TEAM');
    const existId: any = teamsMarked.findIndex(
      (elem: any) => elem.idTeam === team.idTeam
    );
    localStorage.removeItem(this.teamKey);
    if (existId > -1) {
      const favoriteId = this.v1favoriteTeamIds()[team.idTeam];

      this.http
        .delete<any>(`${this.urlAPI}favorites/${favoriteId}`)
        .subscribe((response) => {
          if (response.success) {
            teamsMarked.splice(existId, 1);
            localStorage.setItem(this.teamKey, JSON.stringify(teamsMarked));
            this.changeTeamFavorites.emit(this.getFavoriteFromLocal('TEAM'));

            this.changeFavorites.emit();
          }
        });
      // this.getFavorites(true).subscribe(({ data }) => {
      //   const favoriteId = data.TeamFavorites.find(
      //     (x: any) => x.idMatch === team.id
      //   )?.favoriteId;
      //   this.http
      //     .delete<any>(`${this.urlAPI}favorites/${favoriteId}`)
      //     .subscribe((response) => {
      //       if (response.success) {
      //         teamsMarked.splice(existId, 1);
      //         localStorage.setItem(this.teamKey, JSON.stringify(teamsMarked));
      //         this.changeFavorites.emit();
      //       }
      //     });
      // });
    } else {
      const jsonData = {
        idTeam: team.idTeam,
        logo:
          team.national === 1
            ? team.logoCountry
            : team.logo != ''
            ? team.logo
            : team.logoCountry,
        nameEs: team.nameEs,
        nameEn: team.nameEn,
        sport: hasSport ? hasSport : this.sportsServices.getSelectedSport(),
        countryEs: team.countryEs,
        countryEn: team.countryEn,
        logoCountry: team.logoCountry,
      };
      this.http
        .post<any>(`${this.urlAPI}user/favorites`, {
          deviceId: this.deviceId,
          type: 'team',
          record_id: team.idTeam,
          jsonData,
          language: this.translatorService.getCurrentLanguage(),
          sport: hasSport ? hasSport : this.sportsServices.getSelectedSport(),
          uid: this.authServices.userInfo.user?.id,
        })
        .subscribe(() => {
          teamsMarked.unshift(jsonData);
          teamsMarked.sort((a: any, b: any) =>
            parseInt(a.dateMatch) < parseInt(b.dateMatch)
              ? 1
              : parseInt(a.dateMatch) > parseInt(b.dateMatch)
              ? -1
              : 0
          );
          localStorage.setItem(this.teamKey, JSON.stringify(teamsMarked));
          this.changeTeamFavorites.emit(this.getFavoriteFromLocal('TEAM'));

          this.validateTeamFavoriteWhenAdded(team.idTeam);

          this.changeFavorites.emit();
        });
    }
    return true;
  }

  putTeamsSearch(teams: any) {
    localStorage.removeItem('TeamsSearch');
    localStorage.setItem('TeamsSearch', JSON.stringify(teams));
  }

  putCompetitionsSearch(competitions: any) {
    localStorage.removeItem('CompetitionsSearch');
    localStorage.setItem('CompetitionsSearch', JSON.stringify(competitions));
  }

  getTeamsSearch(): any {
    const teams: any = localStorage.getItem('TeamsSearch');
    return teams ? JSON.parse(teams) : [];
  }

  getCompetitionsSearch(): any {
    const competitions: any = localStorage.getItem('CompetitionsSearch');
    return competitions ? JSON.parse(competitions) : [];
  }
  // TODO: delete favorito
  // getFavorites(isAll?: boolean, date: string = ''): Observable<any> {
  //   return this.http
  //     .post<any>(
  //       `${this.urlAPI}user/allfavorites${
  //         !isAll ? '/' + this.sportsServices.getSelectedSport() : ''
  //       }`,
  //       {
  //         date,
  //         deviceId: this.deviceId,
  //         uid: this.authServices.userInfo.user?.id || '',
  //       }
  //     )
  //     .pipe(
  //       map((response) => {
  //         localStorage.setItem(
  //           this.matchKey,
  //           JSON.stringify(response.data.MatchesFavorites)
  //         );
  //         this.newsFavoritesService.idsMatchesFavorites.set(
  //           response.data.MatchesFavorites.map((x: any) => {
  //             this.validateMatchFavoriteWhenAdded(x.idMatch);
  //             this.v1favoriteMatchIds.update((prev) => ({
  //               ...prev,
  //               [x.idMatch]: x.favoriteId,
  //             }));
  //             return x.idMatch;
  //           })
  //         );
  //         localStorage.setItem(
  //           this.competitionKey,
  //           JSON.stringify(response.data.CompetitionFavorites)
  //         );
  //         this.newsFavoritesService.idsCompetitionFavorites.set(
  //           response.data.CompetitionFavorites.map((x: any) => {
  //             this.validateCompettionFavoriteWhenAdded(x.idCompetition);
  //             this.v1favoriteCompetitionIds.update((prev) => ({
  //               ...prev,
  //               [x.idCompetition]: x.favoriteId,
  //             }));
  //             return x.idCompetition;
  //           })
  //         );
  //         localStorage.setItem(
  //           this.teamKey,
  //           JSON.stringify(response.data.TeamFavorites)
  //         );
  //         this.newsFavoritesService.idsTeamFavorites.set(
  //           response.data.TeamFavorites.map((x: any) => {
  //             this.validateTeamFavoriteWhenAdded(x.idTeam);
  //             this.v1favoriteTeamIds.update((prev) => ({
  //               ...prev,
  //               [x.idTeam]: x.favoriteId,
  //             }));
  //             return x.idTeam;
  //           })
  //         );
  //         return response;
  //       })
  //     );
  // }

  validateCompettionFavoriteWhenDelete(id: string) {
    this.localStorageDeleteV2Favorite(id, 'idListCompetitionFavorites');
  }
  validateTeamFavoriteWhenDelete(id: string) {
    this.localStorageDeleteV2Favorite(id, 'idListTeamFavorites');
  }
  validateMatchFavoriteWhenDelete(id: string) {
    this.localStorageDeleteV2Favorite(id, 'idListMatchFavorites');
  }
  validateCompettionFavoriteWhenAdded(id: string) {
    this.localStorageAddV2Favorite(id, 'idListCompetitionFavorites');
  }
  validateTeamFavoriteWhenAdded(id: string) {
    this.localStorageAddV2Favorite(id, 'idListTeamFavorites');
  }
  validateMatchFavoriteWhenAdded(id: string) {
    this.localStorageAddV2Favorite(id, 'idListMatchFavorites');
  }

  localStorageDeleteV2Favorite(id: string, keyLocal: string) {
    const localData: string | null = localStorage.getItem(keyLocal);
    if (!localData) return;

    const listFavoritesNew: string[] = JSON.parse(localData);

    const newData = listFavoritesNew.filter((item) => item !== id);
    if (newData) {
      localStorage.setItem(keyLocal, JSON.stringify(newData));
    }
  }

  localStorageAddV2Favorite(id: string, keyLocal: string) {
    const localData: string | null = localStorage.getItem(keyLocal);
    // console.log({ localData });
    const listFavoritesNew: string[] =
      localData !== null ? JSON.parse(localData) : [];
    if (listFavoritesNew.length === 0) {
      // this.newsCompetitionFavoriteService.idsCompetitionFavorites.update(
      //   (prev) => [...prev, id]
      // );
      localStorage.setItem(keyLocal, JSON.stringify([id]));
      // console.log('no hay pero agrego');
      return;
    }

    // console.log('hay y agrego');

    if (listFavoritesNew.includes(id)) return;
    // this.newsCompetitionFavoriteService.idsCompetitionFavorites.update(
    //   (prev) => [...prev, id]
    // );
    listFavoritesNew.push(id);
    localStorage.setItem(keyLocal, JSON.stringify(listFavoritesNew));
    // const newData = listFavoritesNew.filter((item) => item !== id);
    // if (newData) {
    //   localStorage.setItem(keyLocal, JSON.stringify(newData));
    // }
  }
}
